import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {useTranslation} from '../../../hooks/useTranslation';

export default function FacilitySelect({
  currentFacility,
  setCurrentFacility,
  facilityData,
  setCurrentStations,
  setStationsOptions,
  setTerminalsOptions,
  readOnly = false,
}) {
  const {t} = useTranslation();
  const [facilityOptions, setFacilityOptions] = useState([]);

  useEffect(() => {
    if (facilityData) {
      let options = [];
      facilityData?.forEach(item => {
        options = [
          ...options,
          {label: item?.name, value: item?.id, stations: item?.stations},
        ];
      });
      setFacilityOptions(options);
    }
  }, [facilityData]);

  useEffect(() => {
    if (currentFacility?.stations) {
      setCurrentStations(null);
      let options = [];
      currentFacility?.stations?.forEach(item => {
        options = [
          ...options,
          {label: item?.name, value: item?.id, terminals: item?.terminals},
        ];
      });
      setStationsOptions(options);
      setTerminalsOptions([]);
    }
  }, [currentFacility]);

  return (
    <label htmlFor=''>
      {t('createEquipment.labels.facility')}
      <div title={readOnly ? t('createEquipment.readOnly') : undefined}>
      <Select
        options={facilityOptions}
        onChange={selected => {
          setCurrentFacility(selected);
        }}
        value={currentFacility}
        isDisabled={readOnly}
        placeholder={t('createEquipment.placeholders.facility')}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
            borderRadius: 8,
            width: 534,
            height: 42,
            backgroundColor: readOnly ? '#E9EAEB' : '#F4F5F6',
            cursor: readOnly ? 'not-allowed' : 'default',
          }),
        }}
      />
      </div>
    </label>
  );
}
